// import DocumentSelect from './DocumentSelect'
const DocumentSelect = r => require.ensure([], () => r(require('./DocumentSelect.vue')), 'documentselect-components-chunk')

export default DocumentSelect
